import { useParams } from 'react-router-dom';
import BaseSiteLayout from "../../layouts/BaseSiteLayout/BaseSiteLayout";
import Typography from "../../components/Typography/Typography";
import blogData from "../../routes/Blog/blogData.json"
import { ArrowLeft } from "lucide-react";
import Button from "../../components/Button/Button";
import { useNavigate } from "react-router-dom";

export default function BlogDetail() {
    const { id } = useParams();
    const blogId = parseInt(id, 10);
    const { blogItems } = blogData;

    const navigate = useNavigate();

    const blogPost = blogItems.find(item => item.id === blogId);

    const handleGoBack = () => {
        navigate(-1);
      };

    if (!blogPost) {
        return (
            <BaseSiteLayout>
                <div className="p-8">
                    <Typography size="32" weight="sb">Articolo non trovato</Typography>
                    <p>Ops! Non abbiamo trovato l’articolo che stai cercando.</p>
                </div>
            </BaseSiteLayout>
        );
    }

    return (
        <BaseSiteLayout>
            <div className="pb-8 max-w-3xl mx-auto flex flex-col gap-6">
                <Button
                    icon={<ArrowLeft size={16} />}
                    size="md"
                    type="bw"
                    onClick={handleGoBack}
                />

                {/* Titolo */}
                <Typography size="48" weight="sb" family="serif">
                    {blogPost.title}
                </Typography>

                {/* Meta info: data, lettura, tag */}
                <div className="flex flex-wrap items-center gap-1 md:gap-2 text-sm text-gray-600">
                    <span>{blogPost.date}</span>

                    <span className="w-1 h-1 bg-gray-400 rounded-full mx-2" />

                    <span>Da leggere in {blogPost.readTime} minuti</span>

                    {blogPost.tags && blogPost.tags.length > 0 && (
                        <>
                            <span className="w-1 h-1 bg-gray-400 rounded-full mx-2" />
                            {blogPost.tags.map((tag, index) => (
                                <div key={tag} className="flex items-center">
                                    <span>{tag.charAt(0).toUpperCase() + tag.slice(1)}</span>
                                    {index < blogPost.tags.length - 1 && (
                                        <span className="w-1 h-1 bg-gray-200 rounded-full mx-2" />
                                    )}
                                </div>
                            ))}
                        </>
                    )}
                </div>

                {/* Immagine */}
                <img
                    src={`/${blogPost.imageHD || blogPost.image}`}
                    alt={blogPost.title}
                />

                {/* Contenuto */}
                <div className="prose prose-lg max-w-none" dangerouslySetInnerHTML={{ __html: blogPost.content }}>
                </div>
            </div>
        </BaseSiteLayout>
    );
}